const APP_BASE_PATH = '/value-tracker';
const STC_BASE_PATH = '/sell-my-car';
const SRP_BASE_PATH = '/cars';

export { APP_BASE_PATH, STC_BASE_PATH, SRP_BASE_PATH };
